let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("gTkz8")]).then(() => parcelRequire('jzA8h'));